import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getClientUrl } from '~services/utils';  // eslint-disable-line

const propTypes = {
  match: PropTypes.object, // Injected by React Router
};

class Widget extends Component {
  componentDidMount() {
    document.querySelector('meta[name="viewport"]').content =
      'width=device-width, initial-scale=1';

    const script = document.createElement('script');

    script.async = true;
    script.src = `${getClientUrl()}/zeckit-widget.js`;

    document.body.appendChild(script);
  }

  render() {
    const { match } = this.props;
    const { identifier } = match.params;

    return <div id="zeckit-widget" data-business-id={identifier} />;
  }
}

Widget.propTypes = propTypes;

export default Widget;
